import { Grid } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import classNames from 'classnames';
import React from 'react';
import Draggable from 'react-draggable';

import TnTypography from '../tn-typography/TnTypography';

interface IProps {
  classes?: any;
  open: boolean;
  handleClose: any;
  headerLabel?: string;
  hideBackdrop?: boolean;
  closeOnOutsideClick?: boolean;
  customClass?: any;
  bigger?: boolean;
  large?: boolean;
  extraLarge?: any;
  footerContent?: React.ReactNode;
  headerContent?: React.ReactNode;
}

class TnModal extends React.Component<IProps, any> {
  componentDidMount() {
    document.addEventListener('keydown', this.handleEscapeKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKey, false);
  }

  handleEscapeKey = (event: any) => {
    if (event.keyCode === 27) {
      this.props.handleClose();
    }
  };

  render() {
    const {
      classes,
      customClass,
      open,
      handleClose,
      headerLabel,
      hideBackdrop,
      closeOnOutsideClick,
      children,
      bigger,
      large,
      extraLarge,
      footerContent,
      headerContent,
    } = this.props;

    return (
      <Modal
        open={open}
        hideBackdrop={hideBackdrop}
        onBackdropClick={() => {
          if (closeOnOutsideClick) {
            handleClose();
          }
        }}
        style={{ zIndex: 10006, overflow: 'scroll' }}
      >
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
          <Paper
            elevation={2}
            className={
              customClass
                ? customClass
                : classNames({
                    [classes.paper]: true,
                    [classes.biggerModal]: bigger,
                    [classes.largeModal]: large,
                    [classes.extraLargeModal]: extraLarge,
                  })
            }
          >
            <Grid container className={classes.modalContainer}>
              <Grid container xs={12} className={classes.headerContainer}>
                <Grid item xs={12} className={classes.header}>
                  <Grid container justify={'space-around'}>
                    <Grid item xs={10}>
                      <Grid
                        container
                        alignItems={'center'}
                        className={classes.headerTitleBar}
                        id="draggable-dialog-title"
                      >
                        <Grid item>
                          <TnTypography variant="subtitle2" className={classes.headerTitle}>
                            {headerLabel}
                          </TnTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={1}>
                      <Grid container alignItems={'center'} justify={'flex-end'} className={classes.headerTitleBar}>
                        <Grid item>
                          <Close className={classes.close} onClick={handleClose} data-testid={'Modal_Close'} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {headerContent}
              </Grid>
              <Grid
                id="modalBody"
                item
                xs={12}
                className={classNames(classes.content)}
                style={{ paddingBottom: footerContent ? '60px' : '16px' }}
              >
                {children}
              </Grid>
              {footerContent && (
                <Grid item xs={12} className={classes.footer}>
                  {footerContent}
                </Grid>
              )}
            </Grid>
          </Paper>
        </Draggable>
      </Modal>
    );
  }
}

export default withStyles((theme: any) => ({
  paper: {
    position: 'relative',
    width: '33.62%',
    minHeight: '200px',
    outline: 'none',
    backgroundColor: 'white',
    borderRadius: 8,
    top: '98.46px',
    margin: '0 auto',
    [theme.breakpoints.down('1080')]: {
      width: '90%',
    },
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
  biggerModal: {
    width: '50%',
    [theme.breakpoints.down('1080')]: {
      width: '90%',
      overflowX: 'auto',
    },
  },
  largeModal: {
    width: '70%',
    [theme.breakpoints.down('1080')]: {
      width: '90%',
      overflowX: 'auto',
    },
  },
  extraLargeModal: {
    width: '85%',
    [theme.breakpoints.down('1080')]: {
      width: '90%',
      overflowX: 'auto',
    },
  },
  fullScreenModal: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('1080')]: {
      width: '90%',
      overflowX: 'auto',
    },
  },
  header: {
    backgroundColor: '#000000',
    height: 45,
  },
  headerContainer: {
    position: 'fixed',
    width: '100%',
    display: 'flex',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    flexShrink: 0,
    flexDirection: 'column',
    zIndex: 10007,
  },
  headerTitle: {
    color: '#ffffff',
  },
  content: {
    flexGrow: 1,
    overflowY: 'auto',
    marginTop: 45,
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette?.primary?.main || '#526173',
      borderRadius: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '8px',
    },
    maxHeight: '70vh',
  },
  footer: {
    flexShrink: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    zIndex: 10007,
  },
  headerTitleBar: {
    height: 45,
    cursor: 'move',
  },
  close: {
    color: '#ffffff',
    cursor: 'pointer',
  },
}))(TnModal);
